/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { AuditentriesRequestBuilderRequestsMetadata, type AuditentriesRequestBuilder } from './auditentries/index.js';
// @ts-ignore
import { RevokeRequestBuilderRequestsMetadata, type RevokeRequestBuilder } from './revoke/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /customers/data-sharing-grants/{id}
 */
export interface DataSharingGrantsItemRequestBuilder extends BaseRequestBuilder<DataSharingGrantsItemRequestBuilder> {
    /**
     * The auditentries property
     */
    get auditentries(): AuditentriesRequestBuilder;
    /**
     * The revoke property
     */
    get revoke(): RevokeRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const DataSharingGrantsItemRequestBuilderUriTemplate = "{+baseurl}/customers/data-sharing-grants/{id}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const DataSharingGrantsItemRequestBuilderNavigationMetadata: Record<Exclude<keyof DataSharingGrantsItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    auditentries: {
        requestsMetadata: AuditentriesRequestBuilderRequestsMetadata,
    },
    revoke: {
        requestsMetadata: RevokeRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
